import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import Api from '../services/Api';
import { MovimentacaoEstoqueRequest, Response } from "./Types";


class MovimentacaoEstoqueController {
  public static async Listar(request: MovimentacaoEstoqueRequest): Promise<Response> {
    try {
      const response = await Api.post('api/movimentacaoestoque/Listar', request);
      
      const object = response?.data;

      const retorno: Response = {
          StatusCode: response.status, 
          Data: object,
          ErroDetalhado: undefined
      };
      
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
          StatusCode: error?.response?.status,
          Data: ErrorDictionary(error?.response?.status),
          ErroDetalhado: undefined
      };
      return retorno;
    }
  }
}

export default MovimentacaoEstoqueController;